import { render } from "./contactPage.vue?vue&type=template&id=57ec0dfc&scoped=true"
import script from "./contactPage.vue?vue&type=script&lang=js"
export * from "./contactPage.vue?vue&type=script&lang=js"

import "./contactPage.vue?vue&type=style&index=0&id=57ec0dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ec0dfc"]])

export default __exports__